var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"id":"main-menu-toggle","type":"button","aria-expanded":"false"},on:{"click":_vm.toggleMobileMenu}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }